// import { initializeApp } from "firebase/app";
export const LOGIN = "LOGIN";
export const PROFILEPIC = "PROFILEPIC";
export const LOGOUT = "LOGOUT";
export const PASSWORD_GENERATE = "PASSWORD_GENERATE";
// export const PASSWORD_GENERATE = "PASSWORD_GENERATE";

// export const PROFILEDEATAILS = "PROFILEDEATAILS";
// export const EDITPASSWORD = "EDITPASSWORD";

// export const ACTIVITYFEED = "ACTIVITYFEED";
// const firebaseConfig = {
//     apiKey: "AIzaSyDAYepm9F5Z4M7WtirzHDFfwLh166CJqng",
//     authDomain: "taxopliance-5dd90.firebaseapp.com",
//     databaseURL: "https://taxopliance-5dd90.firebaseio.com",
//     projectId: "taxopliance-5dd90",
//     storageBucket: "taxopliance-5dd90.appspot.com",
//     messagingSenderId: "18175422347",
//     appId: "1:18175422347:web:7bb8bf3c43bbcc4206498e",
//     measurementId: "G-TEDTTC6JYV"
// };

// export const app = initializeApp(firebaseConfig);


